<template>
  <Modal class="mask long-modal" width="930" style="max-height:80%; over-flow:auto" v-model="show"
         :mask-closable="false">
    <div slot="header" class="modal-header">添加企业合同<span>{{`房间/床位数：${roomsCount}`}}</span></div>
    <Form :model="formData" :label-width="90" :rules="formRules" ref="formData">
      <Row :gutter="16">
        <Col span="7">
          <FormItem label="签约手机号" prop="userPhone">
            <Input v-model="formData.userPhone"></Input>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="企业名称" prop="signName">
            <Input v-model="formData.signName" :disabled="disable"></Input>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem :label-width="90" label="企业地址" prop="businessAddress">
            <Input v-model="formData.businessAddress" :disabled="disable"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="7">
          <FormItem label="代理人" prop="contactsName">
            <Input v-model="formData.contactsName" :disabled="disable"></Input>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="代理人邮箱" prop="contactsMail">
            <Input v-model="formData.contactsMail" :disabled="disable"></Input>
          </FormItem>
        </Col>
        <Col span="9" class="flex">
          <FormItem  class="flexnone" :label-width="90" label="代理人证件号" prop="contactsIdcardType">

          <Select style="width: 100px" v-model="formData.contactsIdcardType">
            <div v-if="createContractData">
              <Option v-for="item in createContractData.contacterTypeEnum" :value="item.value" :key="item.value">
                {{item.text}}
              </Option>

            </div>

          </Select>
          </FormItem>

          <FormItem :label-width="1"  prop="contactsIdcard" class="flexauto">
            <Input v-model="formData.contactsIdcard" :disabled="disable" style="width: 100%;display: block"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="10">
          <FormItem :label-width="1" prop="businessQualification">
            <div class="flex">
              <Select v-model="formData.businessQualificationType" style="width: 78px" class="flexnone">
                <Option v-for="item in companyBusinessQualificationTypeList" :value="item.code" :key="item.code">
                  {{item.name}}
                </Option>
              </Select>
              <Input style="margin-left: 10px;" :maxlength=20 class="flexauto" v-model="formData.businessQualification"
                     placeholder="请输入证件号"></Input>
            </div>

          </FormItem>
          <!--          <div class="flex">-->
          <!--            <FormItem label="" >-->
          <!--              <Select v-model="formData.companyBusinessQualificationType"  style="width: 80px" selected=1>-->
          <!--                <Option v-for="item in companyBusinessQualificationTypeList" :value="item.code" :key="item.code">-->
          <!--                  {{item.name}}-->
          <!--                </Option>-->
          <!--              </Select>-->
          <!--            </FormItem>-->
          <!--            <FormItem label="" >-->
          <!--              <Input v-model="formData.businessQualification" placeholder="请输入证件号" style="width: 140px"></Input>-->
          <!--            </FormItem>-->
          <!--          </div>-->
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="10">
          <div class="ivu-form-item-required ivu-form-item ">
            <span style="width:82px;" class="inline-b ivu-form-item-label"
                  v-if="formData.businessQualificationType ===1">营业执照</span>
            <span style="width:82px;" class="inline-b ivu-form-item-label"
                  v-if="formData.businessQualificationType ===3">法人证书</span>
            <div style="display:flex;">
              <div class="upload-wrap">
                <img class="imgwidth" v-if="formData.businessQualificationPic[0].url"
                     :src="formData.businessQualificationPic[0].url"
                     @click="showImg(formData.businessQualificationPic[0].url)"/>
                <Upload
                  :action="baseUrl+'/file/uploadFile'"
                  :on-success="setLicense1"
                  :headers="{'Access-Token':token}"
                  :show-upload-list="false"
                  :format="['jpg','jpeg','png']"
                  :on-format-error="handleFormatError"
                >
                  <div v-if="!formData.businessQualificationPic[0].url" class="upload"
                       :class="{error: !validateLicense1}">
                    <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
                    <p>点击上传图片</p>
                  </div>
                  <a v-if="!formData.businessQualificationPic[0].url && !validateLicense1" class="error-color"
                     href="javascript:;">请上传企业资质证明</a>
                  <a v-if="formData.businessQualificationPic[0].url" href="javascript:;" style="position: relative;left: 10px">修改</a>
                </Upload>
              </div>
            </div>
          </div>
        </Col>
        <Col span="10">
          <div class="ivu-form-item-required ivu-form-item ">
            <span style="width:110px;" class="inline-b ivu-form-item-label">租房事务委托书</span>
            <div class="upload-wrap">
              <img class="imgwidth" v-if="formData.proxyPic[0].url" :src="formData.proxyPic[0].url"
                   @click="showImg(formData.proxyPic[0].url)"/>
              <Upload
                :action="baseUrl+'/file/uploadFile'"
                :on-success="setProxy"
                :headers="{'Access-Token':token}"
                :show-upload-list="false"
                :format="['jpg','jpeg','png']"
                :on-format-error="handleFormatError"
              >
                <div v-if="!formData.proxyPic[0].url" class="upload" :class="{error: !validateProxy}">
                  <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
                  <p>点击上传图片</p>
                </div>
                <a v-if="!formData.proxyPic[0].url && !validateProxy" class="error-color"
                   href="javascript:;">请上传租房事务委托书</a>
                <a v-if="formData.proxyPic[0].url" href="javascript:;">修改</a>
              </Upload>
            </div>
          </div>
        </Col>
      </Row>
    </Form>
    <Form :model="rentData" :label-width="90" :rules="formRules1" ref="calculatePriceForm">
      <div class="box">
        <Row ::gutter="16">
          <Col span="8">
            <FormItem label="客户来源" prop="channelType">
              <Select v-model="rentData.channelType" @on-change="channelTypeChange" class="item-width">
                <Option v-for="item in channelTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem v-if="[1,2].indexOf(rentData.channelType)!==-1" prop="channelUserCode" label="工号">
              <Input v-model="rentData.channelUserCode" placeholder="工号" class="item-width"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem v-if="[1,2].indexOf(rentData.channelType)!==-1" prop="channelUserName" label="姓名">
              <Input v-model="rentData.channelUserName" placeholder="姓名" :disabled="this.channelName" class="item-width"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="8">
            <FormItem label="租期方式" prop="rentType">
              <Select v-model="rentData.rentType" @on-change="clearBackToRentDay" :disabled="disable">
                <Option v-for="item in rentTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="租期时间" prop="conEndDate">
              <Row>
                <Col span="7" style="width:150px; padding-left:0; padding-right:0">
                  <DatePicker type="date" :disabled="true" v-model="rentData.conStartDate"></DatePicker>
                </Col>
                <Col span="7" style="width:158px; padding-left:8px; padding-right:0">
                  <DatePicker v-if="rentData.rentType === 1" type="date" :disabled="disable"
                              v-model="rentData.conEndDate" :options="options1" placeholder="退租日"
                              @on-change="getPayTypeList" :clearable="false"></DatePicker>
                  <DatePicker v-if="rentData.rentType === 2" type="date" :disabled="disable"
                              v-model="rentData.conEndDate" :options="options2" placeholder="退租日"
                              @on-change="getTime"></DatePicker>
                  <DatePicker v-if="rentData.rentType === 0" type="date" :disabled="true" v-model="rentData.conEndDate"
                              placeholder="退租日"></DatePicker>
                </Col>
                <Col span="7">
                  <div class="time-box" v-if="rentData.rentType == 1 && year ">{{year}}年</div>
                  <div class="time-box" v-if="(rentData.rentType == 2 || rentData.rentType == 0) && month">{{month}}月
                  </div>
                  <div class="time-box" v-if="(rentData.rentType == 2 || rentData.rentType == 0)&& day">{{day}}天</div>
                </Col>
              </Row>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="8">
            <FormItem label="付款方式" prop="conCycleCode">
              <Select v-model="rentData.conCycleCode" :disabled="disable" @on-change="calcuatePrice">
                <Option v-for="item in payTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>

        <FormItem label="请选择优惠券" v-if="couponInfoList.length">

          <section style="flex-wrap: wrap" class="flex">
            <div :class="['coupon',!item.isCheck?'nocheck':'',]"
                 v-for="item in couponInfoList"
                 @click.stop="clickCard(item)"
            >
              <div class="flex top">
                <div class="flexauto" style="margin-bottom: 12px">
                  <div class="name">{{item.cardName}}</div>
                  <div class="desc">{{item.description}}</div>
                </div>
                <div class="flexnone money">
                  {{'￥'+item.couponAmount}}
                </div>

              </div>
              <div class="date" style="margin-top: 6px">{{item.subDescription}}</div>
            </div>
          </section>
        </FormItem>


      </div>
      <div class="box">
        <Row :gutter="16" class="activty-wrap">
          <Col span="15">
            <div>
              <div class=" ivu-form-item ">
                <span style="width:150px;" class="inline-b ivu-form-item-label">标准月租金：</span>
                <Input class="item" v-model="price.originRentPrice" :disabled="true">
                  <span slot="append">元/月</span>
                </Input>
              </div>
              <div class="ivu-form-item ">
                <span style="width:150px;" class="inline-b ivu-form-item-label">实际月租金：</span>
                <Input class="item" v-model="price.rentPrice" :disabled="true">
                  <span slot="append">元/月</span>
                </Input>
              </div>
              <div class="ivu-form-item ">
                <div style="width:150px;" class="inline-b ivu-form-item-label">标准服务费：
                  <div class="inline-b tip-wrap ">
                    <Icon class="sup-icon" type="ios-help-outline"></Icon>
                    <div v-if="price.serviceWords" class="ivu-tooltip-popper tip">
                      <div class="ivu-tooltip-content">
                        <div class="ivu-tooltip-arrow"></div>
                        <div class="ivu-tooltip-inner">{{price.serviceWords}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <Input class="item" v-model="price.originServicePrice" :disabled="true">
                  <span slot="append">元</span>
                </Input>
              </div>
              <div class="ivu-form-item ">
                <span style="width:150px;" class="inline-b ivu-form-item-label">实际服务费：</span>
                <Input class="item" v-model="price.servicePrice" :disabled="true">
                  <span slot="append">元</span>
                </Input>
              </div>
              <div class="ivu-form-item ">
                <div style="width:150px;" class="inline-b ivu-form-item-label">标准押金：
                  <div class="inline-b tip-wrap">
                    <Icon class="sup-icon" type="ios-help-outline"></Icon>
                    <div v-if="price.depositWords" class="ivu-tooltip-popper tip">
                      <div class="ivu-tooltip-content">
                        <div class="ivu-tooltip-arrow"></div>
                        <div class="ivu-tooltip-inner">{{price.depositWords}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <Input class="item" v-model="price.originDepositPrice" :disabled="true">
                  <span slot="append">元</span>
                </Input>
              </div>
              <div class="ivu-form-item ">
                <span style="width:150px;" class="inline-b ivu-form-item-label">实际押金：</span>
                <Input class="item" v-model="price.depositPrice" :disabled="true">
                  <span slot="append">元</span>
                </Input>
              </div>
            </div>
          </Col>
          <Col span="9" v-if="discounts">
            <div class="activity">
              <div class="activity-item" v-for="(item,i) in discounts" :key="`item-${i}`">
                <h4>{{item.name}}</h4>
                <div>
                  <p v-for="(discountsItem,index) in item.details" :key="`discountsItem-${index}`">
                    {{`${discountsItem.name}：${discountsItem.count}`}}</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Form>
    <billing-details :n="billingKey" :closeKey="closeBillingKey" :isRead="isRead" :tableData="paymentTermsDtos"
                     :roomsCount="roomsCount" :totalMoney="price.totalMoney"
                     @createContract="createContract"></billing-details>
    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="checkBilling">账单明细</Button>
        <Button type="primary" size="large" @click="validateForm">
          <span>创建合同</span>
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script type="text/ecmascript-6">
  import {getBaseUrl} from "@/utils/public";
  import {getToken} from "@/utils/auth";
  import {formatDateTime} from "@/utils/format";
  import { getEHRUserDetail } from 'api/managementCenter';
  import {
    findCustomerQualification,
    calculatePrice,
    createContract,
    choosePayment,
    getQualificationChooses

  } from "api/enterprisecontract";
  import BillingDetails from './BillingDetails'

  export default {
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
      getQualificationChooses().then(res => {
        res.data && (this.companyBusinessQualificationTypeList = res.data)
      }).catch(error => {
      })
      // this.formData.businessQualificationType = this.companyBusinessQualificationTypeList[0].code
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      projectFid: {
        type: String,
        default: ''
      },
      roomsCount: {
        type: Number,
        default: 0
      },
      roomIds: {
        type: String,
        default: ''
      },
      createContractData: {
        type: Object,
        default: null
      },
      contractSubject: {
        type: Object,
        default: null
      },
      isReservation: {
        type: Number,
        default: 0
      }
    },
    watch: {
      n() {
        this.clearData()
        this.show = true
      },
      createContractData: {
        deep: true,
        handler(val) {
          this.rentTypeList = val.leaseTime
          this.stockMaxSignDate = val.roomCanRent.stockMaxSignDate
          this.maxRentDay = val.roomCanRent.maxRentDay
          this.maxRentYear = val.roomCanRent.maxRentYear
          this.minRentDay = val.roomCanRent.minRentDay
          this.minRentYear = val.roomCanRent.minRentYear
          this.channelTypeList = val.channelType
        }
      },
      contractSubject: {
        deep: true,
        handler(val) {
          this.formData.contactsIdcardType=val.contactsIdcardType
          this.formData.userPhone = val.userPhone
          this.formData.signName = val.signName
          this.formData.businessAddress = val.businessAddress
          this.formData.contactsName = val.contactsName
          this.formData.contactsMail = val.contactsMail
          this.formData.contactsIdcard = val.contactsIdcard
          this.formData.businessQualificationType = val.businessQualificationType
          this.formData.businessQualification = val.businessQualification
          this.formData.customerUid = val.userUuid
          this.rentData.customerUid = val.userUuid
          if(val.businessQualificationPicFid){
            this.formData.businessQualificationPic[0].fid = val.businessQualificationPicFid
            this.formData.businessQualificationPic[0].url = val.businessQualificationPicUrl
            this.validateLicense1 = true
          }
          if(val.proxyPicFid){
            this.formData.proxyPic[0].fid = val.proxyPicFid
            this.formData.proxyPic[0].url = val.proxyPicUrl
            this.validateProxy = true
          }
        }
      }
    },
    components: {
      BillingDetails
    },
    data() {
      const validateContactPhone = (rule, value, callback) => {
        let pattern = /^1\d{10}$/


        //电话变了清理数据
        this.formData.signName = ""
        this.formData.businessAddress = ""
        this.formData.businessQualification = ""
        this.formData.contactsIdcard = ""
        this.formData.customerUid = ""
        this.rentData.customerUid = ""
        // this.rentData.conEndDate=""
        // this.rentData.rentType=''
        this.rentData.conCycleCode = ''
        // this.payTypeList=[]
        for (let key in this.price) {
          if (key === 'totalMoney') {
            this.price.totalMoney = 0
          } else {
            this.price[key] = ''
          }
        }
        this.discounts = null
        this.couponInfoList = []


        if (!pattern.test(value)) {
          this.disable = true
          callback(new Error('输入正确的联系方式'));
        } else {
          //cosnole.log(this.formData.customerUid)
          // if (!this.formData.customerUid) {
          findCustomerQualification(value,this.projectFid).then(res => {
            this.disable = false
            this.formData.signName = res.data.companyName
            this.formData.businessAddress = res.data.companyAddress
            this.formData.businessQualification = res.data.businessLicence
            // this.formData.contactsName = res.data.contacterName
            this.formData.contactsIdcard = res.data.contacterNum
            this.formData.customerUid = res.data.customerUid
            this.rentData.customerUid = res.data.customerUid
            // this.formData.contacterPhone = res.data.contacterPhone
            this.formData.contactsIdcardType=res.data.contactsIdcardType
          })

          // }
          callback();

        }
      }
      const validateEmail = (rule, value, callback) => {
        const pattern = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if (!pattern.test(value)) {
          callback(new Error('输入正确的邮箱'));
        } else {
          callback();
        }
      }
      const validateId = (rule, value, callback) => {
        const pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!pattern.test(value)) {
          callback(new Error('输入正确的身份证号'));
        } else {
          callback();
        }
      }
      const validateQualification = (rule, value, callback) => {
        const pattern = /^[A-Za-z0-9]+$/;
        if (!pattern.test(value) || value.length > 20) {
          callback(new Error('输入正确的证件号'));
        } else {
          callback();
        }
      }
      const validateChannelUserCode = (rule, value, callback) => {
        let pattern = /^[0-9]*$/

        if(!pattern.test(value)){
          this.rentData.channelUserName = ''
          this.rentData.channelUserPhone = ''
          this.rentData.channelContrastJobCode = ''
          this.rentData.channelSuperEmpCode = ''
          this.rentData.channelDept = ''
          this.rentData.channelDeptCode = ''
          this.rentData.channelCenter = ''
          this.rentData.channelCenterCode = ''
          this.rentData.channelGroup = ''
          this.rentData.channelGroupCode = ''
          callback(new Error('输入正确的工号'));
        }else {
          if(!this.sendUp){
            this.rentData.channelUserName = ''
            this.rentData.channelUserPhone = ''
            this.rentData.channelContrastJobCode = ''
            this.rentData.channelSuperEmpCode = ''
            this.rentData.channelDept = ''
            this.rentData.channelDeptCode = ''
            this.rentData.channelCenter = ''
            this.rentData.channelCenterCode = ''
            this.rentData.channelGroup = ''
            this.rentData.channelGroupCode = ''

            getEHRUserDetail({userCode:this.rentData.channelUserCode}).then( res => {
              if(res.code !== 0 ) {
                this.channelName = false
                this.$Message.error(res.message);
              } else {
                if (res.data.name) {
                  this.channelName = true
                  this.rentData.channelUserName = res.data.name
                  this.rentData.channelUserPhone = res.data.phone
                  this.rentData.channelContrastJobCode = res.data.contrastJobCode
                  this.rentData.channelSuperEmpCode = res.data.superEmpCode
                  this.rentData.channelDept = res.data.dept
                  this.rentData.channelDeptCode = res.data.deptCode
                  this.rentData.channelCenter = res.data.center
                  this.rentData.channelCenterCode = res.data.centerCode
                  this.rentData.channelGroup = res.data.groupName
                  this.rentData.channelGroupCode = res.data.groupCode
                } else {
                  this.channelName = false
                  this.$Message.error("未查询到管家信息,请输入管家姓名");
                }
                callback();
              }
            })
          }else {
            callback();
          }
        }
      }
      return {
        "couponInfoList": [],

        isClear: false,
        billingKey: 0,
        closeBillingKey: 0,
        isRead: true,
        show: false,
        sendUp:false,
        channelName:true,
        baseUrl: '',
        token: '',
        disable: false,
        stockMaxSignDate: 0, // 最大签约日
        maxRentDay: 0,
        maxRentYear: 0,
        minRentDay: 0,
        minRentYear: 0,
        year: 0,
        month: 0,
        day: 0,
        rentTypeList: [],
        channelTypeList:[],
        rentData: {
          conCycleCode: '', // 付款方式：1 月付 3 季付 6 半年付 12 年付 9 一次性付清 ,
          conEndDate: '',
          conStartDate: formatDateTime(new Date(), false),
          contractType: 0, // 0新签 1 续约
          customerUid: '',
          projectFid: '',
          rentType: '',
          stockFid: '',
          subjectType: 3,
          channelType: '',
          channelUserCode: '',
          channelUserName: '',
          channelUserPhone: '',
          channelSuperEmpCode: '',
          channelContrastJobCode: '',
          channelDept: '',
          channelDeptCode: '',
          channelCenter: '',
          channelCenterCode: '',
          channelGroup: '',
          channelGroupCode: ''
        },
        formData: {
          contactsIdcardType:null,  //证件类型
          subjectType: 3,
          customerUid: '',
          userPhone: '',
          signName: '',
          businessAddress: '',
          contactsName: '',
          contactsMail: '',
          contactsIdcard: '',
          businessQualification: '',
          businessQualificationType: 1, // 1 营业执照 2 法人证书
          businessQualificationPic: [
            {
              fid: '',
              url: ''
            }
          ],
          proxyPic: [
            {
              fid: '',
              url: ''
            }
          ]
        },
        validateLicense1: true,
        validateProxy: true,
        companyQualificationList: [],
        payTypeList: [],
        formRules: {
          // contactsIdcard:[{required: true, message: " ", trigger: "blur", type: "string"}],
          contactsIdcardType:[{required: true, message: " ", trigger: "change", type: "number"}],
          userPhone: [{required: true, validator: validateContactPhone, trigger: 'blur'}],
          signName: [{required: true, message: '请输入企业名称', trigger: 'blur', type: 'string'}],
          businessAddress: [{required: true, message: '请输企业地址', trigger: 'blur', type: 'string'}],
          contactsName: [{required: true, message: '请输联系人', trigger: 'blur', type: 'string'}],
          contactsMail: [{required: true, validator: validateEmail, trigger: 'blur'}],
          contactsIdcard: [{required: true,message: '请输入证件号', trigger: 'blur'}],
          businessQualification: [{required: true, validator: validateQualification, type: 'string', trigger: 'blur'}],
          businessQualificationType: [{required: true, message: "请选择企业资质类型", trigger: "change", type: "number"}],
        },
        formRules1: {
          conCycleCode: [{required: true, message: '请选择付款方式', trigger: 'change', type: 'string'}],
          conEndDate: [{required: true, message: '请选择退租时间', trigger: 'change', type: 'object'}],
          rentType: [{required: true, message: '请选择租期方式', trigger: 'change', type: 'number'}],
          channelType:[ {required:true, type:'number', message:'请选择客户来源', trigger:'change'}],
          channelUserCode:[{ required:true, validator:validateChannelUserCode, trigger:'blur' }],
          channelUserName:[{ required:true, message:'请输入姓名', trigger:'change',type:'string' }]
        },
        price: {
          depositPrice: '', //实际押金
          originDepositPrice: '',// 标准押金
          originRentPrice: '', // 标准房租
          originServicePrice: '', // 标准服务费
          rentPrice: '', // 实际房租
          servicePrice: '', // 实际服务费
          totalMoney: 0, // 总金额
          depositWords: '',
          serviceWords: '',
        },
        discounts: null,
        paymentTermsDtos: [],
        creatdData: null,
        companyBusinessQualificationTypeList: []
      };
    },
    computed: {
      options1() {
        let _this = this
        let shortcuts = []

        let min = this.minRentYear
        let max = this.maxRentYear
        let temDate = 0
        let temDateArr = []
        for (let i = min; i < max + 1; i++) {
          temDate = this.setDate(i)
          if (temDate.valueOf() > this.stockMaxSignDate) {
            max = i - 1;
            break;
          }
        }
        for (let i = min; i < max + 1; i++) {

          shortcuts.push({
            text: `${i}年`,
            value() {
              return _this.setDate(i)
            },
            onClick: (picker) => {
              _this.year = i
            }
          })
        }
        return {
          disabledDate(date) {
            return date && date.valueOf();
          },
          shortcuts: shortcuts
        }

      },
      options2() {
        let max = this.maxRentDay
        let min = this.minRentDay
        let now = new Date()

        let minTime = now.valueOf() + 3600 * 24 * 1000 * (min - 2)
        let maxTime = now.valueOf() + 3600 * 24 * 1000 * (max - 1)

        minTime = minTime > this.stockMaxSignDate ? this.stockMaxSignDate : minTime
        maxTime = maxTime > this.stockMaxSignDate ? this.stockMaxSignDate : maxTime
        return {
          disabledDate(date) {
            return date && date.valueOf() < minTime || date.valueOf() > maxTime;
          }
        }
      }
    },
    methods: {
      clickCard(item) {

        this.couponInfoList.forEach(ele => {
          ele.cardId !== item.cardId && (ele.isCheck = 0)
        })
        item.isCheck = item.isCheck === 0 ? 1 : 0
        this.calcuatePrice(this.rentData.conCycleCode, 1)

      },
      clearBackToRentDay(val) {

        this.rentData.conCycleCode = ""
        for (let key in this.price) {
          if (key === 'totalMoney') {
            this.price.totalMoney = 0
          } else {
            this.price[key] = ''
          }
        }
        this.discounts = null
        this.couponInfoList = []


        this.rentData.conEndDate = ''
        this.year = 0
        this.month = 0
        this.day = 0
        if (val === 0) {
          this.rentData.conEndDate = formatDateTime(this.stockMaxSignDate, false)
          this.getTime(this.rentData.conEndDate)
          // this.getPayTypeList(this.rentData.conEndDate)
        } else if (val === 2) {
          let endDate = new Date().valueOf() + 3600 * 24 * 1000 * (this.minRentDay - 1)
          let nowDate = new Date()
          let arr = this.getDateArry(formatDateTime(nowDate, false), formatDateTime(endDate, false))
          if (arr[1] === 0) {
            this.rentData.conEndDate = formatDateTime(endDate, false)
          } else {
            let endDate1 = new Date()
            endDate1.setMonth(nowDate.getMonth() + arr[0] + 1)
            endDate1.setDate(endDate1.getDate() - 1)
            this.rentData.conEndDate = formatDateTime(endDate1, false)
          }
          this.getTime(this.rentData.conEndDate)
        } else if (val === 1) {
          this.year = this.minRentYear;
          this.rentData.conEndDate = this.setDate(this.minRentYear);
          this.getPayTypeList(this.rentData.conEndDate);
        }
      },
      calcuatePrice(val, type) {
        if (!val) return
        this.rentData.projectFid = this.projectFid
        this.rentData.stockFid = this.roomIds
        if (this.rentData.customerUid === '') {
          this.$Message.info('请先验证手机号')
          this.$nextTick(() => {
            this.rentData.conCycleCode = ""
          })

          return
        }
        this.sendUp = true
        this.$refs['calculatePriceForm'].validate(bool => {
          this.sendUp = false
          if (bool) {
            let data = Object.assign({}, this.rentData)
            if (typeof data.conEndDate == 'object') {
              data.conEndDate = formatDateTime(data.conEndDate, false)
            }
            if (typeof data.conStartDate == 'object') {
              data.conStartDate = formatDateTime(data.conStartDate, false)
            }

            let cardIds = []
            this.couponInfoList.forEach(ele => {
              ele.isCheck && cardIds.push(ele.cardId)
            })

            data['type'] = type ? type : 0
            data['cardIds'] = cardIds


            calculatePrice(data).then(res => {
              this.price.depositPrice = res.data.depositPrice
              this.price.originDepositPrice = res.data.originDepositPrice
              this.price.originRentPrice = res.data.originRentPrice
              this.price.originServicePrice = res.data.originServicePrice
              this.price.rentPrice = res.data.rentPrice
              this.price.servicePrice = res.data.servicePrice
              this.price.totalMoney = res.data.totalMoney
              this.price.serviceWords = res.data.serviceWords
              this.price.depositWords = res.data.depositWords
              this.discounts = res.data.discounts
              this.paymentTermsDtos = res.data.paymentTermsDtos ? res.data.paymentTermsDtos : []

              if (this.paymentTermsDtos.length === 1) {
                this.couponInfoList = this.paymentTermsDtos[0].couponShowInfoVos ? this.paymentTermsDtos[0].couponShowInfoVos : []
              }


            })
          }
        })
      },
      checkBilling() {
        this.isRead = true
        this.billingKey++
      },
      getPayTypeList(val) {
        if (val && (this.rentData.rentType === 0 || this.rentData.rentType)) {
          let conStartDate = formatDateTime(this.rentData.conStartDate, false)
          let data = {
            conEndDate: val,
            conStartDate: conStartDate,
            projectFid: this.projectFid,
            rentType: this.rentData.rentType,
          }
          choosePayment(data).then(res => {
            this.payTypeList = res.data
          })
        }
      },
      validateForm() {
        this.sendUp = true
        this.$refs['calculatePriceForm'].validate(bool => {
          this.sendUp = false
          if (!this.formData.businessQualificationPic[0].url) {
            this.validateLicense1 = false
          }
          if (!this.formData.proxyPic[0].url) {
            this.validateProxy = false
          }
          if (bool && this.validateLicense1 && this.validateProxy) {
            // 调接口
            this.creatdData = Object.assign({}, this.rentData)
            this.creatdData.contractSignSubject = Object.assign({}, this.formData)
            this.creatdData.stockFids = this.roomIds
            this.isRead = false
            this.billingKey++
          }
        })
      },
      createContract() {
        if (this.creatdData) {
          let data = this.creatdData
          if (typeof data.conStartDate == 'object') {
            data.conStartDate = formatDateTime(data.conStartDate, false)
          }
          if (typeof data == 'object') {
            data.conEndDate = formatDateTime(data.conEndDate, false)
          }

          if(this.isReservation === 1){
            data.isReservation = 1
          }
          let cardIds = []
          this.couponInfoList.forEach(ele => {
            ele.isCheck && cardIds.push(ele.cardId)
          })
          data['cardIds'] = cardIds
          createContract(data).then(res => {
            this.$Message.success('创建合同成功!');
            this.show = false
            this.$emit('close-modal')
            this.closeBillingKey++

          }).catch(res => {
            console.log(res)
          })
        }
      },
      getTime(val) {
        if (!val) return
        this.rentData.conCycleCode = ''
        this.getPayTypeList(val)
        const now = new Date()
        let curYear = now.getFullYear()
        let curMonth = now.getMonth()
        let curDate = now.getDate()

        let dateArr = val.split('-')
        let year = +dateArr[0]
        let month = +dateArr[1] - 1
        let date = +dateArr[2]

        let arr = this.calcuateDuration(year, month, date, curYear, curMonth, curDate)
        this.month = arr[0]
        this.day = arr[1]
      },
      getDateArry(d1, d2) {
        let s1 = d1.split("-")
        let s2 = d2.split("-")
        return this.calcuateDuration(s2[0], s2[1], s2[2], s1[0], s1[1], s1[2])
      },
      clearData() {
        for (let key in this.price) {
          if (key === 'totalMoney') {
            this.price.totalMoney = 0
          } else {
            this.price[key] = ''
          }
        }
        this.formData.businessQualificationPic.forEach(item => {
          item.fid = ''
          item.url = ''
        })
        this.formData.proxyPic.forEach(item => {
          item.fid = ''
          item.url = ''
        })
        this.paymentTermsDtos.length = 0
        this.discounts = null

        this.validateLicense1 = true
        this.validateProxy = true
        this.formData.customerUid = ''
        this.$refs['calculatePriceForm'].resetFields();
        this.$refs['formData'].resetFields();


        this.couponInfoList = []
      },
      calcuateDuration(year, month, date, curYear, curMonth, curDate) {
        // month 当月实际数减1
        let diffMonth = 0
        let diffDay = 0

        let curMonthDays = new Date(year, month + 1, 0).getDate()
        let preMonthDays = new Date(year, month, 0).getDate() // 获取上个月的天数

        if (date >= curDate) {
          diffDay = date - curDate + 1
          diffMonth = year - curYear > 0 ? month - curMonth + 12 : month - curMonth
        } else {
          if (date === curDate - 1 || date === curMonthDays) {
            diffDay = 0
            diffMonth = year - curYear > 0 ? month - curMonth + 12 : month - curMonth
          } else {
            diffDay = preMonthDays - curDate + 1 <= 0 ? date : preMonthDays - curDate + 1 + date
            diffMonth = year - curYear > 0 ? month - curMonth + 11 : month - curMonth - 1
          }
        }
        return [diffMonth, diffDay]
      },
      setLicense1(response) {
        this.formData.businessQualificationPic[0].fid = response.data.fid
        this.formData.businessQualificationPic[0].url = response.data.url
        this.validateLicense1 = true
      },
      setProxy(response) {
        this.formData.proxyPic[0].fid = response.data.fid
        this.formData.proxyPic[0].url = response.data.url
        this.validateProxy = true
      },
      handleFormatError() {
        this.$Message.error('请输入jpg,jpeg,png,格式的文件')
      },
      showImg(img) {
        this.$emit('show-img', img)
      },
      setDate(num) {
        let date = new Date();
        if (date) {
          let year = date.getFullYear() + num
          let month = date.getMonth()
          let day = date.getDate() - 1
          return new Date(year, month, day)
          // return `${year}-${month}-${day}`;
        }
      },
      channelTypeChange() {
        this.rentData.channelUserCode = ''
        this.rentData.channelUserName = ''
        this.rentData.channelUserPhone = ''
        this.rentData.channelSuperEmpCode = ''
        this.rentData.channelContrastJobCode = ''
        this.rentData.channelDept = ''
        this.rentData.channelDeptCode = ''
        this.rentData.channelCenter = ''
        this.rentData.channelCenterCode = ''
        this.rentData.channelGroup = ''
        this.rentData.channelGroupCode = ''
      }
    }
  }
</script>

<style lang="css" scoped>
  .box {
    padding-top: 24px;
    border-top: 1px solid #DDDEE1;
  }

  .imgwidth {
    width: 167px;
    height: 118px;
  }

  a {
    color: #CFA868;
  }

  .upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
  }

  .upload-wrap {
    display: inline-block;
    line-height: 1;
    padding: 10px 4px;
  }

  .ivu-date-picker {
    width: 100%;
  }

  .time-box {
    margin-left: 8px;
    display: inline-block;
    padding-left: 8px;
    padding-right: 8px;
    line-height: 30px;
    border: 1px solid #DDDEE1;
    border-radius: 2px;
  }

  .item {
    width: 200px;
  }

  .sup-icon {
    position: relative;
    top: -10px;
    left: -6px;
  }

  .activty-wrap {
    display: flex;
    align-items: center;
  }

  .activity-item {
    display: flex;
    line-height: 24px;
    margin-bottom: 12px;
  }

  .activity-item h4 {
    width: 80px;
    margin-right: 20px;
    text-align: right;
  }

  .activity-item p {
    color: #CFA868;
  }

  .upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;

  }

  .ivu-upload {
    position: relative;

  }

  .ivu-upload a {
    position: absolute;
    right: 0;
    bottom: -6px;
  }

  .upload.error {
    border-color: #F56356;
  }

  a.error-color {
    color: #F56356;
    bottom: -18px;

  }

  .tip-wrap {
    position: absolute;
  }

  .tip {
    display: none;
    position: absolute;
    bottom: 26px;
  }

  .sup-icon:hover + .tip {
    display: inline-block;
  }


</style>
